'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var utils = require('@chakra-ui/utils');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

/**
 * AccordionSquareIcon
 *
 * Wraps an icon in a square box; used with an icon before the accordion heading.
 */
var AccordionSquareIcon = react.forwardRef(function (props, ref) {
  var _className = utils.cx('chakra-accordion__square-icon', props.className);
  var styles = react.useStyles();
  return /*#__PURE__*/React__default["default"].createElement(react.chakra.span, _extends__default["default"]({
    "aria-hidden": true,
    className: _className,
    __css: styles.squareIcon
  }, props, {
    ref: ref
  }));
});
AccordionSquareIcon.displayName = 'AccordionSquareIcon';
exports.AccordionSquareIcon = AccordionSquareIcon;